(() => {
  if (window.jzProductTextScale) return;
  window.jzProductTextScale = true;
  const original = new Map();
  let pending = false;
  const selector = '.shopify-section:has(.product-information), .shopify-section:has(.product-recommendations), .shopify-section:has(.jewelzit-gallery)';
  function update() {
    pending = false;
    for (const [element, value] of original) {
      if (value.size) element.style.setProperty('font-size', value.size, value.priority);
      else element.style.removeProperty('font-size');
      if (!element.isConnected) original.delete(element);
    }
    const measurements = [];
    document.querySelectorAll(selector).forEach(root => {
      root.querySelectorAll('*').forEach(element => {
        if (element.closest('svg, script, style, template') || element.tagName === 'OPTION') return;
        const hasText = Array.from(element.childNodes).some(node => node.nodeType === 3 && node.textContent.trim());
        if (!hasText && !element.matches('input, select, textarea')) return;
        const size = parseFloat(getComputedStyle(element).fontSize);
        if (!Number.isFinite(size)) return;
        if (!original.has(element)) original.set(element, {size:element.style.getPropertyValue('font-size'), priority:element.style.getPropertyPriority('font-size')});
        measurements.push([element, size * 1.2]);
      });
    });
    measurements.forEach(([element, size]) => element.style.setProperty('font-size', size + 'px', 'important'));
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }
  function init() {
    update();
    new MutationObserver(records => {
      if (records.some(record => record.target.nodeType === 1 && (record.target.closest(selector) || Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector('.product-information')))))) schedule();
    }).observe(document.body, {childList:true, subtree:true});
    window.addEventListener('resize', schedule, {passive:true});
    document.addEventListener('shopify:section:load', schedule);
    if (document.fonts) document.fonts.ready.then(schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
